export enum STATE {
    OPEN = 'OPEN',
    CANCELLED = 'CANCELLED',
    CLOSED = 'CLOSED',
    CREATED = 'CREATED',
    PENDING = 'PENDING',
    SPOOLED = 'SPOOLED',
    DELETED = 'DELETED',
    FAILED = 'FAILED',
    EXPIRED = 'EXPIRED',
    DRAFT = 'DRAFT',
}

export enum STATE_DETAIL {
    ABG = 'ABG',
    ADB = 'ADB',
    AGB = 'AGB',
    AFP = 'AFP',
    AFU = 'AFU',
    AML = 'AML',
    BAM = 'BAM',
    BAN = 'BAN',
    BBC = 'BBC',
    BLA = 'BLA',
    BNZ = 'BNZ',
    BPA = 'BPA',
    BPR = 'BPR',
    CBA = 'CBA',
    CBB = 'CBB',
    CHK = 'CHK',
    COS = 'COS',
    CRE = 'CRE',
    CSA = 'CSA',
    DDB = 'DDB',
    DDC = 'DDC',
    DDD = 'DDD',
    DDL = 'DDL',
    DEL = 'DEL',
    EEI = 'EEI',
    ENE = 'ENE',
    FAD = 'FAD',
    FIC = 'FIC',
    FID = 'FID',
    FIH = 'FIH',
    FIK = 'FIK',
    FIM = 'FIM',
    FIN = 'FIN',
    FIR = 'FIR',
    FIX = 'FIX',
    FRD = 'FRD',
    FUS = 'FUS',
    FWD = 'FWD',
    IFF = 'IFF',
    IFT = 'IFT',
    INB = 'INB',
    IPA = 'IPA',
    IPB = 'IPB',
    IPC = 'IPC',
    IPD = 'IPD',
    IPE = 'IPE',
    ISA = 'ISA',
    KAG = 'KAG',
    LGR = 'LGR',
    MIP = 'MIP',
    MIX = 'MIX',
    MPP = 'MPP',
    NBA = 'NBA',
    NGA = 'NGA',
    NGD = 'NGD',
    OBG = 'OBG',
    OFL = 'OFL',
    OPN = 'OPN',
    PNR = 'PNR',
    PSI = 'PSI',
    RBC = 'RBC',
    RDE = 'RDE',
    REC = 'REC',
    RED = 'RED',
    RID = 'RID',
    RPS = 'RPS',
    RVK = 'RVK',
    SBR = 'SBR',
    SID = 'SID',
    SIP = 'SIP',
    SNM = 'SNM',
    STO = 'STO',
    SUS = 'SUS',
    TAF = 'TAF',
    TRM = 'TRM',
    UNG = 'UNG',
    UNK = 'UNK',
    VIP = 'VIP',
    WDA = 'WDA',
    WDP = 'WDP',
    WDU = 'WDU',
    WEA = 'WEA',
    WEP = 'WEP',
    WER = 'WER',
    WEU = 'WEU',
    WFP = 'WFP',
    XPR = 'XPR',
    XXX = 'XXX',
}
